<script lang="ts">
    import type {UIcons} from 'shared/ui-widgets/uicons/types';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import {exists} from 'shared/utils/custom-utils';

    export let icon: UIcons | null = null;
    export let buttonStyle: 'default' | 'accent-blue' | 'brand-orange' | 'danger' = 'default';
</script>

<button class="kp-context-menu-button {buttonStyle}-style" on:click>
    <span class="button-label">
        <slot/>
    </span>

    {#if exists(icon)}
        <span class="icon-container">
            <UIcon {icon} color="inherit"/>
        </span>
    {/if}
</button>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .kp-context-menu-button {
        width: 100%;
        cursor: pointer;
        outline: none;
        border: none;
        background: none;
        display: flex;
        align-items: center;
        gap: @spacing-s;
        border-radius: @border-radius-default;
        padding: @spacing-xs @spacing-s;
        transition: background-color 0.3s ease-in-out;

        &:hover {
            background-color: @themed-body-bg-blue-highlighted;
        }

        &.default-style {
            color: @themed-text-default;
        }

        &.danger-style {
            color: var(--danger-red);
        }

        &.accent-blue-style {
            color: var(--accent-blue);
        }

        &.brand-orange-style {
            color: var(--brand-orange);
        }

        .button-label {
            font-size: @font-size-small;
            flex: 1;
            text-align: start;
        }

        .icon-container {
            font-size: @font-size-small;
        }
    }
</style>